<script lang="ts">
    import { useLocation } from "svelte-navigator";
    import { locationStore } from "../../../../../store/locations";
    import { networkStore } from "../../../../../store/networks";
    import NetworkCard from "./NetworkCard.svelte";

    const location = useLocation();
</script>

{#if $location.pathname !== "/tools/provision"}
    <div class="columns">
        <!-- Left side -->
        <div class="column is-5 ">
            {#if $networkStore && $networkStore.network}
                <NetworkCard
                    network={$networkStore.network}
                    clickable={false}
                    mainImage={false}
                />
            {/if}
        </div>
        <!-- Right side -->
        <div class="column is-7">
            {#if $locationStore && $locationStore.location}
                <div class="card full-height full-width">
                    <div class="card-content">
                        <div class="media">
                            <div class="media-content">
                                <p class="title is-4">
                                    {$locationStore.location.name}
                                </p>
                            </div>
                        </div>

                        <div class="content">
                            <p>
                                {$locationStore.location.address
                                    .addressLine1}{$locationStore.location
                                    .address.addressLine2
                                    ? " " +
                                      $locationStore.location.address
                                          .addressLine2
                                    : ""}, {$locationStore.location.address
                                    .postalCode}, {$locationStore.location
                                    .address.city}
                            </p>
                        </div>
                    </div>
                </div>
            {/if}
        </div>
    </div>

    <hr />
{/if}

<style>
    .full-height {
        height: 100%;
    }

    .full-width {
        width: 100%;
    }
</style>
